export const sortSelectedItemsToTop = <T, V>(
    items: T[],
    selectedValues: V | V[] | undefined,
    getValue: (item: T) => V
): T[] => {
    const isMulti = Array.isArray(selectedValues);

    return [...items].sort((a, b) => {
        const aValue = getValue(a);
        const bValue = getValue(b);

        const aSelected = isMulti ? selectedValues?.includes(aValue) : selectedValues === aValue;
        const bSelected = isMulti ? selectedValues?.includes(bValue) : selectedValues === bValue;

        if (aSelected && !bSelected) return -1;
        if (!aSelected && bSelected) return 1;
        return 0;
    });
};
